import { put, select, call } from "redux-saga/effects";
import { defineMessages } from "react-intl";
import { showAlert, ALERT_TYPES } from "./alert/alertActions";

export const messages = defineMessages({
    apiError: {
        id: "alerts.make-api-call.error",
        defaultMessage: "{error}",
        description: "makeAPI error alert message",
    },
});

export const makeApiCall = function* (fn, ...args) {
    const token = yield select(getToken);
    const { err, result } = yield call(fn, token, ...args);
    handleApiErrorGeneric((alert) => put(alert), err, result, messages, ALERT_TYPES);
    return result;
};

export const makeApiCallWithParentErrorHandling = function* (fn, ...args) {
    const token = yield select(getToken);
    const apiResponse = yield call(fn, token, ...args);
    if (apiResponse.err) {
        throw apiResponse;
    }
    return apiResponse.result;
};

export const getLocale = (state) => state.domain.locale;
export const getToken = (state) => state.login.bearerToken;
export const getUserProfile = (state) => state.login.userProfile;
export const getTasks = (state) => state.tasks.value;
export const getKeycloak = (state) => state.login.keycloak;
export const getTechnicianInfo = (state) => state.login.technicianInfo;
export const getCreationDateObject = (state) => state.dashboard.creationDate;
export const getVenderNumber = (state) => state.login.technicianInfo && state.login.technicianInfo.vendorNumber;
export const getUserSelectedContract = (state) => {
    let contracts = [];
    let savedState = state?.dashboard?.filter?.items;
    if (!!savedState && savedState.length > 0) {
        savedState.forEach((el) => {
            contracts.push(el?.contractNumber);
        });
    }
    return contracts;
};
export const getUserSelectedStatus = (state) => {
    let allStatuses = [];
    let savedState = state?.dashboard?.allStatuses?.items;
    if (!!savedState && savedState.length > 0) {
        savedState.forEach((el) => {
            allStatuses.push(el?.id);
        });
    }
    return allStatuses;
};

export const handleApiErrorGeneric = function* (dispatchFn, err, result) {
    if (err && err.message) {
        yield dispatchFn(showAlert(Date.now(), messages.apiError, ALERT_TYPES.error, { error: err.message }));
        return true;
    }
    if (result && result.statusCodeValue !== undefined && (result.statusCodeValue < 200 || result.statusCodeValue >= 300) && result.message) {
        yield dispatchFn(showAlert(Date.now(), messages.apiError, ALERT_TYPES.error, { error: result.body }));
        return true;
    }
    if (result && result.success === false && result.message) {
        yield dispatchFn(showAlert(Date.now(), messages.apiError, ALERT_TYPES.error, { error: result.message }));
        return true;
    }
    return false;
};
